import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";

import propertyRoutes from "routes/property";
import cleaningRoutes from "routes/cleaning";
import Navbar from "navbar";
import Footer from "footer";
import {
  propertyFooterRoutes,
  cleaningFooterRoutes,
  workforceFooterRoutes,
  suppliesFooterRoutes,
} from "routes/footers";

import PropertyPage from "pages/PropertyPage";
import GatePage from "pages/GatePage";
import WorkforceApp from "pages/WorkforceApp";
import CleaningPage from "pages/CleaningPage";
import SuppliesPage from "pages/SuppliesPage";

const propertyOnlyPaths = ["/let-only/", "/full/", "/block/"];

function AppShell() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const isCleaningPath = pathname.startsWith("/cleaning");
  const isPropertyPath = propertyOnlyPaths.includes(pathname) || pathname.startsWith("/property");
  const isSuppliesPath = pathname.startsWith("/supplies");

  useEffect(() => {
    if (isPropertyPath) {
      sessionStorage.setItem("section", "property");
    } else if (isCleaningPath) {
      sessionStorage.setItem("section", "cleaning");
    } else if (isSuppliesPath) {
      sessionStorage.setItem("section", "supplies");
    }
  }, [pathname, isPropertyPath, isCleaningPath, isSuppliesPath]);

  const isGate = pathname === "/";
  const isWorkforce = pathname.startsWith("/workforce");
  const isSupplies = isSuppliesPath;

  const lastSection = sessionStorage.getItem("section") || "property";
  const isCleaning =
    isCleaningPath || (!isPropertyPath && !isSuppliesPath && lastSection === "cleaning");

  const activeRoutes = isCleaning ? cleaningRoutes : propertyRoutes;
  const showMuiNavbar = !isGate && !isWorkforce && !isSupplies;

  const getRoutes = (allRoutes) =>
    allRoutes.map((route, index) => {
      if (route.collapse) return getRoutes(route.collapse);
      if (route.route)
        return <Route exact path={route.route} element={route.component} key={index} />;
      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {showMuiNavbar && (
        <Navbar routes={activeRoutes} section={isCleaning ? "cleaning" : "property"} />
      )}

      <Routes>
        <Route path="/" element={<GatePage />} />
        <Route path="/workforce/" element={<WorkforceApp />} />
        <Route path="/property/" element={<PropertyPage />} />
        <Route path="/cleaning/" element={<CleaningPage />} />
        <Route path="/supplies/" element={<SuppliesPage />} />
        {getRoutes(propertyRoutes)}
        {getRoutes(cleaningRoutes)}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {!isGate && (
        <Footer
          content={
            isWorkforce
              ? workforceFooterRoutes
              : isSupplies
              ? suppliesFooterRoutes
              : isCleaning
              ? cleaningFooterRoutes
              : propertyFooterRoutes
          }
          mt={isWorkforce || isSupplies ? 3 : 0}
        />
      )}
    </ThemeProvider>
  );
}

export default AppShell;
